<template>
    <a-modal title="记录审核" v-model="shenheData.show" @ok="doShenhe" @cancel="cancelShenhe" okText="确定" cancelText="取消">
        <a-form :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
            <a-form-item label="尺寸复核人">
                <a-input v-model="shenheData.fuheren" placeholder="请填写尺寸复核人" />
            </a-form-item>
            <a-form-item label="见证人">
                <a-input v-model="shenheData.jianzhengren" placeholder="请填写见证人" />
            </a-form-item>
        </a-form>
    </a-modal>
</template>

<style lang="scss" scoped>

</style>

<script>
export default {
    props: ['id'],
    data() {
        return {
            formItemLayout: {
                labelCol: {
                    span: 4,
                },
                wrapperCol: {
                    span: 20,
                },
            },
            shenheData: {
                show: true,
                fuheren: '',
                jianzhengren: ''
            }
        };
    },
    async created() {
    },
    methods: {
        cancelShenhe() {
            this.$emit('tongguoCallBack', {status: -1})
        },
        async doShenhe() {
            if(!this.shenheData.fuheren) {
                this.$message.error('请输入尺寸复核人')
                return
            }
            if(!this.shenheData.jianzhengren) {
                this.$message.error('请输入见证人')
                return
            }
            const that = this
            const r = await this.$axios.post("/chicun/doShenhe", {
                id: this.id,
                status: 1,
                fuheren: that.shenheData.fuheren,
                jianzhengren: that.shenheData.jianzhengren
            });
            if (r.status == 1) {
                // this.$message.success('操作成功')
                this.$emit('tongguoCallBack', {status: 1})
            } else {
                this.$message.error('操作失败...')
            }
        },
    },
};
</script>